// src/components/ChatInterface/OptionsGrid.jsx
import React from "react";
import { migrationRolesData } from "../data/migrationRolesData";

const OptionsGrid = ({ handleSelectOption }) => {
  return (
    <div className="px-4 pb-4">
      <div className="mb-2 flex justify-between items-center">
        <h3 className="text-lg font-semibold text-white">Migration Roles</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
        {migrationRolesData.map((option, index) => (
          <button
            key={index}
            onClick={() => handleSelectOption(option.title)}
            className="px-3 py-2 bg-white/90 backdrop-blur-sm shadow-lg rounded-lg border border-gray-200 
            hover:bg-blue-50 transition-all duration-200 transform hover:-translate-y-1 
            flex flex-col h-full text-left overflow-hidden"
          >
            <h3
              className="text-lg font-semibold text-blue-800 mb-2"
              title={option.title}
            >
              {option.title}
            </h3>
            <p
              className="text-sm text-gray-600 line-clamp-3 overflow-hidden"
              title={option.description}
            >
              {option.description.substring(0, 80)}...
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default OptionsGrid;
